import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BazisBrowseOptionsComponent } from './browse-options.component';

@UntilDestroy()
@Component({
    selector: 'bazis-browse-options-button',
    templateUrl: './browse-options-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisBrowseOptionsButtonComponent extends BazisBrowseOptionsComponent {}
